import { Injectable } from '@angular/core';
import { EmployeeCategoryModel } from '../employee-category/employee-category/model/employee-category.model';
import { RequestData } from 'src/app/common/models/request-data.model';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class EmployeeService {

  constructor(private http: HttpClient) { }

  getEmployeeList(requestData: RequestData): Observable<any> {
    return this.http.post(environment.baseUrl + '/employee/get', requestData);

  }

  getEmployeeById(id: number): Observable<any> {
    return this.http.post(environment.baseUrl + '/employee/get/' + id, '');

  }
  downloadExcel(requestData: any): Observable<Blob> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    // const url = 'http://yourdomain.com/api/customers/export'; // Adjust URL

    return this.http.post(environment.baseUrl + '/employee/exportdatacsv', requestData, { headers, responseType: 'blob' })
      .pipe(
      //catchError(this.handleError)
    );

  }

  /**
  * 
  * @param employeeInfo 
  * Calls the update API to insert/update the record
  */
  update(employeeInfo: EmployeeCategoryModel): Observable<any> {
    if (employeeInfo.hasOwnProperty("id")) {
      return this.http.post(environment.baseUrl + '/employee/update', employeeInfo);
    } else {
      return this.http.post(environment.baseUrl + '/employee/add', employeeInfo);
    }
  }


  /**
 * 
 * @param employeeInfo 
 * Calls the API to delete the record
 */
  delete(employeeInfo: EmployeeCategoryModel): Observable<any> {
    return this.http.post(environment.baseUrl + '/employee/delete/' + employeeInfo.id, employeeInfo);
  }


  getDepartmentList(requestData: any): Observable<any> {
    return this.http.post(environment.baseUrl + '/department/get', requestData);

  }

  getEmployeeCategoryList(requestData: RequestData): Observable<any> {
    return this.http.post(environment.baseUrl + '/employeecategory/get', requestData);

  }

}
